import { useProtected } from "@/hooks";
import { Outlet } from "react-router-dom";

export const SetupRoot = () => {
  useProtected();
  return <Outlet />;
};

export { CreateOrganizationPage } from "./CreateOrganization";
